import type { ComponentType } from 'react';

import { type Permissions, usePermissions } from '@kp/react-sdk';

export const withPermissions = <P extends object>(
  Component: ComponentType<P>,
  required: Permissions[],
) => {
  const Guarded = (props: P) => {
    const { hasAll } = usePermissions();

    return hasAll(required) ? <Component {...props} /> : null;
  };

  Guarded.displayName = `withPermissions(${
    Component.displayName || Component.name || 'Component'
  })`;

  return Guarded;
};
